import React from 'react';

import { FaFacebookSquare, FaInstagramSquare } from 'react-icons/fa';
// import { BsTwitter } from 'react-icons/bs';
import { IoLogoYoutube } from 'react-icons/io';
import { RiInstagramFill } from 'react-icons/ri';
import { FaSquareXTwitter } from "react-icons/fa6";

import { Styling } from '../theme/styling';

const Social = () => {
    return (
        <div className="w-full xsm:py-[0.25rem] lg:py-2 2xsm:mt-2 2xsm:mb-4 lg:-mt-1 2xl:-mt-2 lg:mb-2 2xsm:text-[1.25rem] xsm:text-[1.5rem] lg:text-[1.25rem] xl:text-[1.25rem] 2xl:text-[1.5rem]">
            <div className={`${Styling.transitionStyleFast} flex flex-row xsm:items-center 2xsm:justify-center lg:items-start lg:justify-start 2xsm:space-x-[2rem] lg:space-x-[1.25rem] 2xl:space-x-[1.5rem] text-lightSecondary`}>
                <a
                    href="https://www.facebook.com/resolyou.mediate/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Resolyou's Facebook Page"
                    className={`${Styling.transitionStyleFast} trns hover:text-darkSecondary `}
                >
                    <FaFacebookSquare />
                </a>
                <a
                    href="https://x.com/resol_youADR"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Resolyou's X Profile"
                    className={`${Styling.transitionStyleFast} trns hover:text-darkSecondary`}
                >
                    <FaSquareXTwitter />
                </a>
                <a
                    href="https://instagram.com/resolyou_mediate"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Resolyou's Instagram Page"
                    className={`${Styling.transitionStyleFast} trns hover:text-darkSecondary `}
                >
                    <RiInstagramFill />
                </a>

                <a
                    href="https://youtube.com/@ResolYou"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Resolyou's YouTube Channel"
                    className={`${Styling.transitionStyleFast} trns hover:text-darkSecondary`}
                >
                    <IoLogoYoutube />
                </a>
            </div>
        </div>
    )
}

export default Social